/**
 * Centralized path constants for admin navigation.
 *
 * These route templates are shared across side-nav and org-switcher configs
 * to maintain a single source of truth. The `:thirdPartySlug` placeholder is
 * substituted at runtime by consumers via `formatRoute()`.
 *
 * Organization structure:
 * - ORG_PATH: Base organization route
 * - BASE_PATH: Base admin path for the organization
 * - Individual feature paths built from BASE_PATH
 */

export const ORG_PATH = '/o/:thirdPartySlug';
export const BASE_PATH = `${ORG_PATH}/admin`;

// Main navigation paths
export const HOME_PATH = `${BASE_PATH}/home`;
export const PROGRAMS_PATH = `${BASE_PATH}/programs`;
export const CONTRACTS_PATH = `${BASE_PATH}/programs/contracts`;
export const LEARNERS_PATH = `${BASE_PATH}/learners`;
export const USERS_PATH = `${BASE_PATH}/users`;
export const ANALYTICS_PATH = `${BASE_PATH}/analytics`;
export const MESSAGES_PATH = `${BASE_PATH}/messages/list/automated`;
export const CUSTOM_COURSES_PATH = `${BASE_PATH}/custom-courses`;
export const ORG_SKILLSETS_PATH = `${BASE_PATH}/skill-sets`;
export const ORG_SKILLS_PATH = `${BASE_PATH}/skills-tracking`;
export const SETTINGS_PATH = `${BASE_PATH}/settings`;

// Organization settings paths
export const ACCOUNT_PATH = `${BASE_PATH}/account`;
export const SSO_CONFIGURE_PATH = `${BASE_PATH}/ssoconfig`;
export const ADMINS_PATH = `${BASE_PATH}/management`;
